var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivepersonPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_3746",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.635742,
    y: 0.274414,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6357 38.6084L15.6357 33.6084H8.96908C8.05241 33.6084 7.26769 33.282 6.61491 32.6292C5.96213 31.9765 5.63574 31.1917 5.63574 30.2751V6.94173C5.63574 6.02507 5.96213 5.24034 6.61491 4.58757C7.26769 3.93479 8.05241 3.6084 8.96908 3.6084H32.3024C33.2191 3.6084 34.0038 3.93479 34.6566 4.58757C35.3094 5.24034 35.6357 6.02507 35.6357 6.94173V30.2751C35.6357 31.1917 35.3094 31.9765 34.6566 32.6292C34.0038 33.282 33.2191 33.6084 32.3024 33.6084H25.6357L20.6357 38.6084ZM8.96908 28.3584C10.4691 26.8862 12.2121 25.7265 14.1982 24.8792C16.1844 24.032 18.3302 23.6084 20.6357 23.6084C22.9413 23.6084 25.0871 24.032 27.0732 24.8792C29.0594 25.7265 30.8024 26.8862 32.3024 28.3584V6.94173H8.96908V28.3584ZM20.6357 20.2751C22.2469 20.2751 23.6219 19.7056 24.7607 18.5667C25.8996 17.4278 26.4691 16.0528 26.4691 14.4417C26.4691 12.8306 25.8996 11.4556 24.7607 10.3167C23.6219 9.17784 22.2469 8.6084 20.6357 8.6084C19.0246 8.6084 17.6496 9.17784 16.5107 10.3167C15.3719 11.4556 14.8024 12.8306 14.8024 14.4417C14.8024 16.0528 15.3719 17.4278 16.5107 18.5667C17.6496 19.7056 19.0246 20.2751 20.6357 20.2751ZM12.3024 30.2751H28.9691V29.8584C27.8024 28.8862 26.5107 28.157 25.0941 27.6709C23.6774 27.1848 22.1913 26.9417 20.6357 26.9417C19.0802 26.9417 17.5941 27.1848 16.1774 27.6709C14.7607 28.157 13.4691 28.8862 12.3024 29.8584V30.2751ZM20.6357 16.9417C19.9413 16.9417 19.351 16.6987 18.8649 16.2126C18.3788 15.7265 18.1357 15.1362 18.1357 14.4417C18.1357 13.7473 18.3788 13.157 18.8649 12.6709C19.351 12.1848 19.9413 11.9417 20.6357 11.9417C21.3302 11.9417 21.9205 12.1848 22.4066 12.6709C22.8927 13.157 23.1357 13.7473 23.1357 14.4417C23.1357 15.1362 22.8927 15.7265 22.4066 16.2126C21.9205 16.6987 21.3302 16.9417 20.6357 16.9417Z",
    fill: "#F2F4F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivepersonPin);
export default __webpack_public_path__ + "static/media/Activeperson_pin.afd0f9cb85d23712434f134f0e246adf.svg";
export { ForwardRef as ReactComponent };